import { render, staticRenderFns } from "./InstitutionServicesCard.vue?vue&type=template&id=2f2c5bfa&scoped=true&"
import script from "./InstitutionServicesCard.vue?vue&type=script&lang=js&"
export * from "./InstitutionServicesCard.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionServicesCard.vue?vue&type=style&index=0&id=2f2c5bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c5bfa",
  null
  
)

export default component.exports